import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  return {
    root: {
      paddingTop: 12,
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        paddingTop: 10
      }
    },
    horseName: {
      marginBottom: 8,
      color: "#2d2d2d",
      fontWeight: 700
    },
    barnStall: {
      marginRight: 4
    }
  };
});
